import React from 'react';
import type {ReactElement} from 'react';
import {IconSize} from '@Components/icon-v2/icon.types';
import styles from './auth-input-error-notification.module.scss';
import {Icon} from '../../../icon-v2';
import {Text, TextSize} from '../../../text';

interface AuthInputErrorNotificationProps {
  errorText: string;
  /** Some messages carry a support link; matches `Text`'s own prop name. */
  dangerouslySetInnerHTML?: boolean;
  'data-testid'?: string;
}

function AuthInputErrorNotification({errorText, dangerouslySetInnerHTML = false, 'data-testid': dataTestId}: AuthInputErrorNotificationProps): ReactElement {
  return (
    <div className={`flexbox ct-error-primary ${styles.errorMessage}`} data-testid={dataTestId}>
      <Icon className={styles.errorIcon} icon="icon-exclamation-triangle" size={IconSize.SIZE_ICON_16} />
      <Text dangerouslySetInnerHTML={dangerouslySetInnerHTML} size={TextSize.SM} val={errorText} />
    </div>
  );
}

export default React.memo(AuthInputErrorNotification);
